import React from "react";
import styles from "./NotFoundContent.module.scss";
import Button from "../../components/UI/button";

const NotFoundContent = () => {
  return (
    <div className={`${styles.errorPageWrapper} d-flex align-items-center`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-9 m-auto text-center">
            <div
              className={`${styles.errorContentCentered} d-flex align-items-center justfy-content-center`}
            >
              <div className={styles.errorPageContentWrap}>
                <h2>404</h2>
                <h3>Page Introuvable</h3>
                <p>

                </p>
                <Button type="link" text="Retour à la page d'acceuil" url="/" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundContent;
